import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header block" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = {
  key: 0,
  class: "detail"
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "title title-left-active"
}
const _hoisted_7 = {
  key: 1,
  class: "detail"
}
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "title title-left-active" }
const _hoisted_10 = { class: "detail-value" }
const _hoisted_11 = { class: "detail-value" }
const _hoisted_12 = { class: "header-r" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "search" }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_export_button = _resolveComponent("export-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.detailType !== '2')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, "派遣单位名称：" + _toDisplayString(_ctx.enterpriseName), 1),
                (_ctx.detailType !== '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "项目名称：" + _toDisplayString(_ctx.projectName), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, "姓名：" + _toDisplayString(_ctx.enterpriseName), 1),
                _createElementVNode("div", _hoisted_9, "身份证：" + _toDisplayString(_ctx.projectName), 1)
              ])),
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "detail-key" }, "创建时间：", -1)),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.timeStart), 1),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "detail-key" }, "结束时间：", -1)),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.timeEnd), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(['header-r-all point',_ctx.queryType === 1 ? 'header-r-active' : '' ] ),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onQueryType(1)))
          }, " 全部 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(['header-r-only point', _ctx.queryType !== 1 ? 'header-r-active' : '' ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onQueryType(0)))
          }, " 仅打卡 ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "请输入姓名/身份证号",
              class: "input search-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchText) = $event)),
              style: {"width":"176px"}
            }, null, 512), [
              [_vModelText, _ctx.searchText]
            ]),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getSignDetailInfo && _ctx.getSignDetailInfo(...args)))
            }, "搜索"),
            _createElementVNode("button", {
              class: "btn-white",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
            }, "重置")
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_export_button, {
              onExport: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onExportVertical()))
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("导出竖版表格")
              ])),
              _: 1
            }),
            _createVNode(_component_export_button, {
              onExport: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onExport()))
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("导出表格")
              ])),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_el_scrollbar, {
          always: "",
          native: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "table",
              style: _normalizeStyle({
                        width:
                            Object.keys(_ctx.tabHeadInfo).length > 6
                                ? Object.keys(_ctx.tabHeadInfo).length * 170 + 'px'
                                : '100%'
                    })
            }, [
              _createVNode(_component_el_table, {
                data: _ctx.tableData,
                "header-row-style": { color: '#202536' },
                "row-style": { color: '#5E617D' },
                "fit:true": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHeadInfo, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      prop: "inex",
                      label: item,
                      key: index,
                      width: index === 0 || index === 3|| index === 4|| index === 5|| index === 6|| index === 7|| index === 8? '100px' : ''
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.tableData[scope.$index][index + 2].indexOf('true') != -1
                                            ? _ctx.tableData[scope.$index][
                                                  index + 2
                                              ].split('true')[0]
                                            : (_ctx.tableData[scope.$index][index + 2] === 'null' ? '暂无' : _ctx.tableData[scope.$index][index + 2])) + " ", 1),
                          (
                                            index + 3 > 7 &&
                                                _ctx.tableData[scope.$index][
                                                    index + 2
                                                ] !== '无' &&
                                                _ctx.tableData[scope.$index][
                                                    index + 2
                                                ].indexOf('true') != -1
                                        )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "point link",
                                onClick: ($event: any) => (
                                            _ctx.preview(
                                                scope.row[0],
                                                scope.row[1],
                                                _ctx.tabHeadInfo[index]
                                            )
                                        )
                              }, _toDisplayString(index + 3 > 7 &&
                                            _ctx.tableData[scope.$index][
                                                index + 2
                                            ] !== '无' &&
                                            _ctx.tableData[scope.$index][
                                                index + 2
                                            ].indexOf('true') != -1
                                                ? '点击查看图片'
                                                : ''), 9, _hoisted_16))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data"])
            ], 4)
          ]),
          _: 1
        }),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _createTextVNode(" " + _toDisplayString(_ctx.previewIndex) + " ", 1),
    (_ctx.showImageViewer)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "hide-on-click-modal": "",
          onClose: _ctx.closeImgViewer,
          "url-list": _ctx.imageList,
          "initial-index": _ctx.previewIndex,
          infinite: _ctx.infinite
        }, null, 8, ["onClose", "url-list", "initial-index", "infinite"]))
      : _createCommentVNode("", true)
  ], 64))
}